import {get, set, toPath, pick} from 'lodash';
import * as utils from "./utils";
import {edit} from './sample';
import schema from './membership_db';
import * as Subprofile from './subprofile';
import * as Order from './order';
import * as Profile from './profile';
import i18n from 'src/i18n';
import sweetalert from 'sweetalert2';
import {DatePicker} from 'element-ui';
import moment from 'moment';

export function title(model) {
  let a = get(model, 'details.profile');
  if (!a) {
    return i18n.fr('schema.member');
  }
  let out = Profile.title.call(this, a);
  if (!out || !out.trim()) {
    out = i18n.fr('no_name');
  }
  return out;
}

export const columns = utils.columnsFn(schema);

/**
 * @param {int} skip default 0
 * @param {int} limit default 20
 * @param {Array<{prop: String, desc: boolean}>} sort column name
 * @param {String} search query
 * @return {Promise<{total: Number, data: Array}>}
 */
export const list = utils.listFn('getMembers', function (payload) {
  if (get(this, 'schemaParams.created_at')) {
    payload.created_at = {
      $gte: +moment(this.schemaParams.created_at).startOf('month'),
      $lte: +moment(this.schemaParams.created_at).endOf('month'),
    };
  }
  return payload;
});
export const view = utils.viewFn('/admin/members/:id');
export const read = utils.readFn('getMemberById', 'member_id');
export const create = utils.createFn('/admin/members/create');

export {edit};

export function tableFilters(schema) {
  if (this.schemaParams) {
    this.schemaParams.created_at = null;
    return [
      h => h(DatePicker.name, {
        props: {
          value: this.schemaParams.created_at,
          type: 'month',
          placeholder: i18n.fr('label_pick_a_month'),
        },
        on: {
          input: v => {
            this.schemaParams.created_at = v;
            this.queryChanged();
          },
        },
      }),
    ];
  }
  return [];
}

export function formActions(model, schema, readonly) {
  let temp = [];

  if (!readonly) {
    // if (debug.DEBUG) { // updated @ 201711291328
    temp.push({
      label: i18n.fr('action.delete') + ' [Del]',
      class: 'btn-danger',
      trigger: e => e.keyCode === 46,
      action: utils.formActions.delete(
        'deleteMemberById',
        'member_id',
        '/admin/' + (['admin', 'superadmin'].indexOf(get(model, 'role')) >= 0 ? 'admins' : 'members')),
    });
    // }
    temp.push({
      label: i18n.fr('action.clear_tokens'),
      class: 'btn-danger',
      action(model, schema) {
        return sweetalert({
          text: i18n.fr('alert.html.confirm_action_$action', {action: '${i18n.action.clear_tokens}'}),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: i18n.fr('action.ok'),
          cancelButtonText: i18n.fr('action.cancel'),
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-fill',
          buttonsStyling: false,
        }).then(() => {
          return utils.updateFn('updateMemberById', 'member_id', [],
            function (payload, schema, columns) {
              payload.tokens = [];
              return payload;
            }).call(this, model, schema);
        }, dismiss => {
        });
      },
    });
    if (!get(model, 'finished_interview')) {
      temp.push({
        label: i18n.fr('action.finished_interview'),
        class: 'btn-success',
        action: utils.updateFn('updateMemberById', 'member_id', {
          finished_interview: 'finished_interview',
        }, function (payload, schema, columns) {
          payload.finished_interview = true;
          return payload;
        }),
      });
    }
    temp.push({
      label: i18n.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: e => (e.metaKey || e.ctrlKey) && e.keyCode === 13,
      action: utils.updateFn('updateMemberById', 'member_id', {
        status: 'status',
        app_config: 'app_config',
        verification: 'verification',
        role: 'role',
        profile: 'details.profile',
        finished_interview: 'finished_interview',
        reset_password: 'reset_password',
        details: 'details',
        certificates: 'certificates',
      }),
    });
  }
  temp.push({
    label: i18n.fr('action.send_feedback_to_caregiver'),
    class: 'btn-success',
    action(model, schema, columns) {
      this.$router.push(`/admin/feedback-admin/create?type=admin_to_caregiver&member_id=${model.member_id}`);
      return Promise.resolve(false);
    },
  });
  temp.push({
    label: i18n.fr('action.send_feedback_to_client'),
    class: 'btn-success',
    action(model, schema, columns) {
      this.$router.push(`/admin/feedback-admin/create?type=admin_to_client&member_id=${model.member_id}`);
      return Promise.resolve(false);
    },
  });
  temp.push({
    label: i18n.fr('create_schema_$name', {name: '${i18n.schema.order}'}),
    class: 'btn-success',
    validation: false,
    async action(model, schema) {
      let self = this;
      let count = await Subprofile.list.call(this, {limit: 1, creator_id: model.member_id});
      if (count.total == 0) {
        await sweetalert({
          title: i18n.fr('alert.html.no_subprofile'),
          text: i18n.fr('alert.html.no_subprofile_desc'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: i18n.fr('action.ok'),
          cancelButtonText: i18n.fr('action.cancel'),
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-fill',
          buttonsStyling: false,
        }).then(() => {
          self.$router.push('/admin/subprofiles/create?member_id=' + model.member_id);
        }, dismiss => {
        });
      } else {
        this.$router.push('/admin/orders/create?member_id=' + model.member_id);
      }
    },
  });
  temp.push({
    label: i18n.fr('action.update_stat'),
    class: 'btn-success',
    action: utils.updateFn('updateMemberStat', 'member_id', []),
  });
  temp.push(utils.formActions.back);
  return temp;
}

export function listActions(schema, readonly) {
  let temp = [];
  temp.push({
    label: i18n.fr('action.export_data'),
    action: utils.exportFn({
      'subprofile.subprofile_id': 'Service User - ID',
      'subprofile.details.profile.first_name': 'Service User - First Name',
      'subprofile.details.profile.last_name': 'Service User - Last Name',
      'subprofile.details.profile.gender': 'Service User - Gender',
      'subprofile.details.profile.birthday': 'Service User - Date of Birth',
      'subprofile.details.medical_history.disease.cancer': 'Service User - Cancer',
      'subprofile.details.medical_history.disease.stroke': 'Service User - Stroke',
      'subprofile.details.medical_history.disease.genetic_disease': 'Service User - Genetic Disease',
      'subprofile.details.medical_history.disease.heart_disease': 'Service User - Heart Disease',
      'subprofile.details.medical_history.disease.hypertension': 'Service User - Hypertension',
      'subprofile.details.medical_history.disease.diabetes': 'Service User - Diabetes',
      'subprofile.details.medical_history.otherDisease': 'Service User - Other Disease',
      'subprofile.details.medical_history.doneSurgery': 'Service User - Done Surgery',
      'subprofile.details.medical_history.surgery': 'Service User - Surgery',
      'subprofile.details.medical_history.mentalTreatment': 'Service User - Mental Treatment',
      'subprofile.details.medical_history.useService': 'Service User - Use Service',

      'subprofile.order.order_id': 'Service User - Order - ID',
      'subprofile.order.product.details.title.en': 'Service User - Order - Type of Service (EN)',
      'subprofile.order.product.details.title.hk': 'Service User - Order - Type of Service (HK)',

      'member_id': 'Membership ID',
      'status': 'Status',
      'created_at': 'Created At',
      'details.profile.first_name': 'First Name',
      'details.profile.last_name': 'Last Name',
      'details.profile.other_name': 'Other Name',
      'details.profile.gender': 'Gender',
      'details.profile.birthday': 'Birthday',
      'verification.email.value': 'Email',
      'verification.phone.value': 'Mobile no.',
      'basic_info_fulfilled': 'Basic info fulfilled',
      'email_fulfilled': 'Email fulfilled',
      'app_config.notification.sms': 'User Preference - SMS',
      'app_config.notification.email': 'User Preference - Email',
      'app_config.notification.promotion': 'Receive Promotion',
      'app_config.language': 'Language',
      'finished_interview': 'Finished interview',
      'details.years_of_experience': 'Years of Experience',
      'details.working_experience': 'Working Experience',

      'stat.rating.admin_to_caregiver_avg': 'Rating - Admin to Caregiver (avg)',
      'stat.rating.admin_to_client_avg': 'Rating - Admin to Client (avg)',
      'stat.rating.client_appointment_feedback_avg': 'Rating - Client appointment feedback (avg)',
      'stat.rating.caregiver_appointment_feedback_avg': 'Rating - Caregiver appointment feedback (avg)',

      'role': 'Role',
      'is_caregiver': 'Is Verified Caregiver',
    }, async function (row, fields) {
      row.basic_info_fulfilled = !!(row.details.profile.first_name
        && row.details.profile.last_name
        && row.details.profile.gender);
      row.email_fulfilled = !!row.verification.email.value;
      row.is_caregiver = !!(row.groups.length || row.finished_interview);
      row.role = row.groups.map(x => x.group.details.code).join('/');

      let filter = x => {
        for (let k in fields) {
          k = toPath(k);
          if (get(x, k) == null) {
            set(x, k, '');
          }
        }
        return pick(x, Object.keys(fields));
      };

      let out = [row];

      let subprofiles = [];
      for (let i = 5; i > 0; --i) {
        try {
          subprofiles = (await Subprofile.list.call(this, {
            skip: 0, limit: 9999999, creator_id: row.member_id, status: {$exists: true},
          }, Subprofile, [])).data;
          break;
        } catch (e) {
        }
      }

      for (let subprofile of subprofiles) {
        let disease = get(subprofile, 'details.medical_history.disease');
        if (disease) {
          for (let key of disease) {
            disease[key] = true;
          }
        }

        out.push({...row, subprofile});

        let orders = [];
        for (let i = 5; i > 0; --i) {
          try {
            orders = (await Order.list.call(this, {
              skip: 0, limit: 9999999, subprofile_id: subprofile.subprofile_id,
            }, Order, [])).data;
            break;
          } catch (e) {
          }
        }

        for (let order of orders) {
          out.push({...row, subprofile: {...subprofile, order: {order_id: order.order_id, product: order.product}}});
        }
      }

      return out.map(filter);
    }),
  });
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/membership.js